








import { Component, Prop, Vue } from 'vue-property-decorator';
import { CardMenuItem } from '../interfaces/card-menu.interface';

@Component
export default class CardMenu extends Vue {
  @Prop() private data: CardMenuItem[];
}
